import { FilledInput, FormControl, InputLabel } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../theme"

interface IProps {
  label: string
  value: string | number | undefined
  backgroundColor?: string
}

export function NonEditableTextField({ label, value, backgroundColor }: Readonly<IProps>): React.JSX.Element {
  return (
    <FormControl fullWidth variant="filled" margin="normal">
      <InputLabel htmlFor="non-editable">{label}</InputLabel>
      <FilledInput
        id="non-editable"
        value={value}
        readOnly
        disableUnderline
        sx={{
          backgroundColor: backgroundColor ?? customPalette.lightWhite,
          borderRadius: 4,
          cursor: "not-allowed",
          pointerEvents: "none",
        }}
      />
    </FormControl>
  )
}
